import { Link } from 'react-router-dom';

export function PaymentCancel() {
  return (
    <div className="min-h-dvh bg-app-bg flex flex-col items-center justify-center px-6 text-center gap-6">
      <div className="w-16 h-16 rounded-full bg-app-muted/15 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-app-muted">
          <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
        </svg>
      </div>
      <div className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-app-fg">Payment cancelled</h1>
        <p className="text-sm text-app-muted leading-relaxed max-w-xs">
          No worries — you can still choose your host whenever you're ready.
        </p>
      </div>
      <Link
        to="/matches"
        className="text-sm font-medium text-gold underline underline-offset-2 hover:brightness-105 transition-all"
      >
        Back to matches
      </Link>
    </div>
  );
}

export default PaymentCancel;
